module.exports = __webpack_public_path__ + "img/p7.27b7b741.png";